export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-CreateBasicTaskWizard01.48dd2537.png";